import { urlApiPasskeyAuthenticationFinish, urlApiPasskeyAuthenticationStart, urlApiPasskeyRegistrationFinish, urlApiPasskeyRegistrationStart, } from "./api.js";
import { postJson } from "./util.js";
function ensurePasskeySupported() {
    if (typeof window === "undefined") {
        throw new Error("Passkey недоступен вне браузера.");
    }
    const w = window;
    if (!w.PublicKeyCredential || !w.navigator?.credentials) {
        throw new Error("Passkey не поддерживается этим браузером.");
    }
}
function unsupportedBrowserError() {
    return new Error("Passkey не поддерживается этим браузером.");
}
function credentialToJSON(cred) {
    const toJSON = cred
        .toJSON;
    if (typeof toJSON !== "function")
        throw unsupportedBrowserError();
    return toJSON.call(cred);
}
function parseCreationOptions(json) {
    const pkc = window
        .PublicKeyCredential;
    if (!pkc?.parseCreationOptionsFromJSON)
        throw unsupportedBrowserError();
    return pkc.parseCreationOptionsFromJSON(json);
}
function parseRequestOptions(json) {
    const pkc = window
        .PublicKeyCredential;
    if (!pkc?.parseRequestOptionsFromJSON)
        throw unsupportedBrowserError();
    return pkc.parseRequestOptionsFromJSON(json);
}
function authenticatorErrorMessage(err, action) {
    const isCreate = action === "create";
    const fallback = isCreate
        ? "Не удалось создать passkey."
        : "Не удалось подтвердить passkey.";
    if (typeof DOMException === "undefined" || !(err instanceof DOMException)) {
        return fallback;
    }
    switch (err.name) {
        case "NotAllowedError":
            return isCreate
                ? "Создание passkey отменено или истекло время ожидания."
                : "Вход по passkey отменен или истекло время ожидания.";
        case "AbortError":
            return "Операция с passkey была прервана.";
        case "InvalidStateError":
            return isCreate
                ? "Этот passkey уже добавлен для аккаунта."
                : "Этот passkey нельзя использовать для входа в этот аккаунт.";
        case "SecurityError":
            return "Браузер заблокировал passkey для этого сайта.";
        case "NotSupportedError":
            return "Этот браузер или authenticator не поддерживает нужный тип passkey.";
        case "ConstraintError":
            return isCreate
                ? "Не удалось создать passkey с выбранным authenticator."
                : fallback;
        default:
            return fallback;
    }
}
export async function registerPasskey() {
    ensurePasskeySupported();
    const start = await postJson(urlApiPasskeyRegistrationStart, {});
    const credCreateOptions = parseCreationOptions(start.options.publicKey);
    let cred;
    try {
        cred = (await navigator.credentials.create({
            publicKey: credCreateOptions,
        }));
    }
    catch (err) {
        console.error(err);
        throw new Error(authenticatorErrorMessage(err, "create"));
    }
    if (!cred)
        throw new Error("Не удалось создать passkey");
    await postJson(urlApiPasskeyRegistrationFinish, {
        credential: credentialToJSON(cred),
    });
}
export async function loginWithPasskey() {
    ensurePasskeySupported();
    const start = await postJson(urlApiPasskeyAuthenticationStart, {});
    const publicKey = parseRequestOptions(start.options.publicKey);
    let cred;
    try {
        cred = (await navigator.credentials.get({
            publicKey,
            mediation: start.mediation,
        }));
    }
    catch (err) {
        console.error(err);
        throw new Error(authenticatorErrorMessage(err, "authenticate"));
    }
    if (!cred)
        throw new Error("Не удалось подтвердить passkey");
    await postJson(urlApiPasskeyAuthenticationFinish, {
        credential: credentialToJSON(cred),
    });
}
